<template>
    <property-base :label="label.text" :forInput="label.for">
        <input v-model="newValue" :name="elementName" class="form-control" :disabled="!canWrite" type="text"/>
        <required fieldName="Name" v-if="!$v.newValue.required"/>
    </property-base>
</template>

<script>
import {required} from 'vuelidate/lib/validators';
    
import {validationMixin} from 'vuelidate';
import resources from '../../../../../../Util/Mixins/resources';
import permissionsMixin from '../../../../Mixins/journey-permissions';
import JourneyConnectionPropertyBase from './../JourneyConnectionPropertyBase.vue';
import RequiredErrorMessage from '../../../../../../Components/Errors/RequiredErrorMessage.vue';

export default {
    name: 'journey-connection-name',
    components: {
        'PropertyBase': JourneyConnectionPropertyBase,
        'Required': RequiredErrorMessage
    },
    mixins: [resources, permissionsMixin, validationMixin],
    created() {
        const vm = this;
        vm.newValue = vm.value;
    },
    validations: {
        newValue: {
            required
        }
    },
    computed: {
        label() {
            return { 
                text:  this.resource('JourneyBuilder_FilterSettings_Name_DisplayName'),
                for: this.elementName
            }
        }
    },
    watch: {
        newValue(value) {
            if(value != this.value) {
                this.$emit('input', value);
            }
        }
    },
    data() {
        return {
            newValue: '',
            elementName: 'Name'
        }
    },
    props: {
        value: {
            type: String,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>

</style>